import { createGrayService } from "@nebula/gray";
import Debugger from "../components/debugger.vue";
import { createApp, h } from "vue";
import { httpService } from "./http";
import "../style/index.scss";

import { install } from "nebula-mobile";
import { sdkService } from "./sdk";

export const grayService = createGrayService({
  async check() {
    const isLocalUrl = "localhost" === location.hostname;
    const isIpUrl = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/.test(location.hostname);
    if (isLocalUrl || isIpUrl || location.hostname !== "cs-nebula.737.com") {
      return false;
    }

    const { status } = await httpService.get({
      url: "https://cs-nebula.737.com/front/-/kong/grayCheck",
      data: {
        company_id: sdkService.options.channel_id,
        app_id: sdkService.options.app_id,
      },
      message: false,
    });

    return Number(status) === 0;
  },
  http: httpService,
  render: (state) => {
    const app = createApp({
      render() {
        return h(Debugger, {
          assest: state.assestList.filter(({ url }) => {
            return !url.includes("notSupport.js");
          }),
          response: state.responseList,
        });
      },
    });
    app.use(install);
    const instance = app.mount(document.createElement("div"));
    return instance.$el;
  },
});
